
export default {
  methods: {

    dataDisplayTableBoolean(value, options = {}) {
      if(value)
        return `<i class="fas fa-check status-active"></i>`
      if(options && options.showFalse)
        return `<i class="fas fa-times status-inactive"></i>`

      return '-'
    },

    dataDisplayTableArea(value) {
      if(value) {
        if (isNaN(value) || value == null)
          value = 0;
        if(typeof value == 'string')
          value = parseFloat(value)

        return value.toFixed(2) + 'm&sup2;'
      }        

      return '-'
    },
  }
}